import axios from 'axios'

export default {
  actions: {

    async getNatification({commit}, data) {
      var result;
      try {
        return await axios
          ('/api/check_updates/', {
            
            method: 'POST',
            data: data
          })
          .then(resp => {
            // console.log(resp)
            return resp
            // resolve(resp)
          })
          .catch(error => console.log(error));
      } catch (e) {
          console.log(e);
          throw e;
      }
    },
    
  }
}